module.exports = __webpack_public_path__ + "static/img/wanted7.1567377.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/mo/zh/wanted7.png
// module id = 9gmz
// module chunks = 1 3